require('./mortgageRequestSignatureDocuments.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ constants
const { LISTA_DOCUMENTOS_FIRMA } = require('constants/links');
const DOCUMENTS_LIST_FILE_TYPE = 'DOCUMENTS_LIST';

// @ actions
const assetsActions = require('actions/mortgageRequest/mortgageRequestAssets');

class MortgageRequestSignatureDocuments extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            email: ''
        };

        this.handleGoToPanel = this.handleGoToPanel.bind(this);
        this.handlePrint = this.handlePrint.bind(this);
    }

    componentWillMount() {
        const { immProfile } = this.props;
        const currentListDevice = immProfile.getIn(['listaDispositivos', 'dispositivo']);
        const currentInternetDevice = currentListDevice.filter(item => item.get('tipoDispositivo').trim() === 'I');
        const currentEmail = currentInternetDevice.getIn([0, 'detalleContacto']);

        this.setState({ email: currentEmail });
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    buildCertificateTooltip() {
        const tooltipContent = (
            <ul>
                {
                    Array(8).fill().map((_, i) => (
                        <li key={i + 1}>
                            <FormattedText value={`mortgageRequestSignatureDocuments-certificateContentText${i + 1}`} />
                        </li>
                    ))
                }
            </ul>
        );

        return (
            <OKTooltip
                content={tooltipContent}
                offset={[10, 0]}
                placement="right"
                title="mortgageRequestSignatureDocuments-certificateContentTitle"
                type="explicative"
            />
        );
    }

    buildConsentTooltip(){
        return (
            <OKTooltip
                content="mortgageRequestSignatureDocuments-consentContentText"
                offset={[10, 0]}
                placement="right"
                title="mortgageRequestSignatureDocuments-consentContentTitle"
                type="explicative"
            />
        );
    }

    handleGoToPanel() {
        this.props.history.push(this.props.linkToPanel);
    }

    handlePrint(event) {
        event && event.preventDefault();

        this.props.getAsset(DOCUMENTS_LIST_FILE_TYPE, true);
    }

    render() {
        const { linkToPanel } = this.props;
        const title = formatText('mortgageRequestSignatureDocuments-title');
        const titleDescription = formatText('mortgageRequestSignatureDocuments-titleDescription');
        const certificateTooltip = this.buildCertificateTooltip();
        const consentTooltip = this.buildConsentTooltip();
        const mailTo = `mailto:${this.state.email}`;

        const itemList = (text1, text2, tooltip) => {
            return (
                <li className="mortgage-request-signature-documents__item">
                    <span className="mortgage-request-signature-documents__item--bold">
                        {text1}
                    </span>
                    <span>
                        {text2}
                        {tooltip}
                    </span>
                </li>
            )
        };


        return (
            <ContentBox>

                <div className="mortgage-request-signature-documents__title">
                    <OKBoxTitle value={title}
                        children={titleDescription} />
                </div>

                <div className="row no-outside-gutter">

                    <ul className="mortgage-request-signature-documents__list list-unstyled col-xs-12">

                        {itemList(formatText('mortgageRequestSignatureDocuments-dniBold'), formatText('mortgageRequestSignatureDocuments-dniText'))}

                        {itemList(formatText('mortgageRequestSignatureDocuments-deedBold'), formatText('mortgageRequestSignatureDocuments-deedText'))}

                        {itemList(formatText('mortgageRequestSignatureDocuments-communityBold'), formatText('mortgageRequestSignatureDocuments-communityText'))}

                        <li className="mortgage-request-signature-documents__item">
                            <span>
                                {formatText('mortgageRequestSignatureDocuments-IBIText')}
                            </span>
                            <span className="mortgage-request-signature-documents__item--bold">
                                {formatText('mortgageRequestSignatureDocuments-IBIBold')}
                            </span>
                        </li>

                        {itemList(formatText('mortgageRequestSignatureDocuments-efficiencyBold'), '')}

                        {itemList(formatText('mortgageRequestSignatureDocuments-certificateBold'), formatText('mortgageRequestSignatureDocuments-certificateText'), certificateTooltip)}

                        {itemList(formatText('mortgageRequestSignatureDocuments-capitulationBold'), formatText('mortgageRequestSignatureDocuments-capitulationText'))}

                        {itemList(formatText('mortgageRequestSignatureDocuments-consentBold'), formatText('mortgageRequestSignatureDocuments-consentText'), consentTooltip)}

                        {itemList(formatText('mortgageRequestSignatureDocuments-bindingOfferBold'), formatText('mortgageRequestSignatureDocuments-bindingOfferText'))}

                        {itemList('', formatText('mortgageRequestSignatureDocuments-andalucíaOnlyText'))}

                    </ul>

                </div>

                <div className="mortgage-request-signature-documents__icons ">
                    <a href={LISTA_DOCUMENTOS_FIRMA} target="_blank">
                        <i className="icon mortgage-request-signature-documents__icon mortgage-request-signature-documents__icon--save"></i>
                    </a>
                    <OKButton onClick={this.handlePrint}
                        loading={false}>
                        <i className="icon mortgage-request-signature-documents__icon mortgage-request-signature-documents__icon--print"></i>
                    </OKButton>
                    <a href={mailTo} >
                        <i className="icon mortgage-request-signature-documents__icon mortgage-request-signature-documents__icon--email"></i>
                    </a>

                </div>

                <div className="mortgage-request-signature-documents__footer row no-outside-gutter">

                    <div className="mortgage-request-signature-documents__text col-xs-10">
                        <OKLink modifier="emphasize" name={'returnLink'}
                            to={linkToPanel} >
                            {formatText('mortgageRequestCommons-returnText')}
                        </OKLink>
                    </div>

                    <div className="col-xs-2">
                        <OKButton block={true}
                            onClick={this.handleGoToPanel}
                            modifier="primary"
                            loading={false}>
                            {formatText('mortgageRequestCommons-acceptText')}
                        </OKButton>
                    </div>

                </div>

            </ContentBox>
        );
    }
}

MortgageRequestSignatureDocuments.propTypes = {
    history: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    linkToPanel: PropTypes.string,
    getAsset: PropTypes.func,
    resetState: PropTypes.func
};

MortgageRequestSignatureDocuments.defaultProps = {
    linkToPanel: '/myprofile/mortgage/panel'
};

module.exports.constructor = MortgageRequestSignatureDocuments;
module.exports.MortgageRequestSignatureDocuments = connect(state => ({
    immProfile: state.profile
}), {
        getAsset: assetsActions.getAsset,
        resetState: assetsActions.resetState
    })(withRouter(MortgageRequestSignatureDocuments));
